import { render, staticRenderFns } from "./dual.vue?vue&type=template&id=5b51b1ce&"
import script from "./dual.vue?vue&type=script&lang=js&"
export * from "./dual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports